import { useEffect } from 'react';
import { AppProvider } from './providers/AppProvider';
import { AppRoutes } from './routes';

import './App.scss';

function App() {

  useEffect(() => {
    // check if the app is running in an iframe
    // and redirect to the top window if it is
    // this prevents the app from being embedded in an iframe
    // which can cause security issues
    // and also ensures the app runs in its own context
    // to avoid potential issues with styling and functionality
    // this is a common practice to prevent clickjacking attacks
    // and to ensure the app is not embedded in other sites
    // that might not be secure or trustworthy
    // this code runs once when the app is mounted
    // and checks if the current window is the top window
    // if not, it redirects to the top window's location
    // this is a simple and effective way to ensure the app runs securely
    // and in its own context
    if (window.top !== window.self) {
      window.top.location = window.location;
    }
  }, []);


  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
}

export default App;
